import { useFetch } from "@/hooks/useFetch";
import { getItemsFromCollection } from "directus/src/operations";

/**
 * Hook to get the latest completed quadrimester
 * @returns {Object} { latestQuadrimesterId, isLoading, error }
 */
export function useLatestQuadrimester() {
  const { data, isLoading, error } = useFetch({
    queryKey: ["latest_quadrimester"],
    queryFn: async () => {
      const query = {
        fields: ["id"],
        filter: {
          status: { _eq: "completed" }
        },
        limit: 1,
        sort: ["-start_date"], // Get the most recent one
      };
      const response = await getItemsFromCollection("performance_review_months", query);
      
      // Return the ID of the latest quadrimester, or null if none found
      return response.length > 0 ? response[0].id : null;
    },
  });

  return {
    latestQuadrimesterId: data,
    isLoading,
    error,
  };
}
